module.exports = __webpack_public_path__ + "static/media/questions-pana-people.eb0abe6f.svg";